if (!customElements.get('wlsn-buybox-description')) {
  class WLSNBuyboxDescription extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        accordion: 'wlsn-accordion',
        buybox: 'wlsn-buybox',
      };

      this.bindMethods = {
        onDescriptionToggleClick: this._onDescriptionToggleClick.bind(this),
      };
    }

    /**
     * Get elements
     * @returns {Object} - Object containing DOM element references
     */
    get elements() {
      return {
        accordion: this.closest(`${this.classes.buybox}`)?.querySelector(`${this.classes.accordion}`),
        descriptionToggle: this.querySelector('[data-action="scroll-to-description"]'),
      };
    }

    /**
     * Connected callback method
     * @returns {void}
     */
    connectedCallback() {
      const { descriptionToggle } = this.elements;
      if (descriptionToggle) {
        descriptionToggle.addEventListener('click', this.bindMethods.onDescriptionToggleClick);
      }
    }

    /**
     * Disconnected callback method
     * @returns {void}
     */
    disconnectedCallback() {
      const { descriptionToggle } = this.elements;
      if (descriptionToggle) {
        descriptionToggle.removeEventListener('click', this.bindMethods.onDescriptionToggleClick);
      }
    }

    /**
     * Handle description toggle click
     * @param {Event} event - Event object
     * @returns {void}
     */
    _onDescriptionToggleClick(event) {
      event.preventDefault();

      const { accordion } = this.elements;

      // No accordion → expand description inline
      if (!accordion) {
        this._expandDescriptionInline();
        return;
      }

      // Has accordion → old behavior (scroll + open)
      const targetIndex = event.currentTarget.getAttribute('data-target-index');
      if (!targetIndex) return;

      const accordionItem = accordion.querySelector(`wlsn-accordion-item[data-index="${targetIndex}"]`);
      if (!accordionItem) return;

      const rect = accordionItem.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const offset = 100;

      window.scrollTo({
        top: rect.top + scrollTop - offset,
        behavior: 'smooth',
      });

      setTimeout(() => {
        window.WLSNHelpers.triggerEvent(accordion, 'wlsn:accordion:open-item', { index: targetIndex });
      }, 100);
    }

    /**
     * Expand description inline when there is no accordion
     * @returns {void}
     */
    _expandDescriptionInline() {
      if (this.dataset.expanded === 'true') return;

      const descriptionInner = this.querySelector('.wlsn-buybox-content__description-text-inner');
      if (!descriptionInner) return;

      const fullText = descriptionInner.dataset.descriptionFull;
      if (!fullText) return;

      descriptionInner.textContent = fullText;

      const toggle = this.querySelector('.js-description-toggle');
      if (toggle) {
        toggle.remove();
      }

      this.dataset.expanded = 'true';
    }
  }

  customElements.define('wlsn-buybox-description', WLSNBuyboxDescription);
}
